import * as Schema from "effect/Schema";

/** Provider-owned, out-of-band metadata, including cumulative native accounting. */
export const ProviderGoal = Schema.Struct({
  objective: Schema.String,
  status: Schema.Literals([
    "active",
    "paused",
    "blocked",
    "usageLimited",
    "budgetLimited",
    "complete",
  ]),
  threadId: Schema.String,
  tokenBudget: Schema.optionalKey(Schema.NullOr(Schema.Number)),
  tokensUsed: Schema.Number,
  timeUsedSeconds: Schema.Number,
  createdAt: Schema.Number,
  updatedAt: Schema.Number,
});
export type ProviderGoal = typeof ProviderGoal.Type;

/** Unknown and failed readback must never masquerade as confirmed absence. */
export const ProviderGoalSnapshot = Schema.Struct({
  state: Schema.Literals(["available", "unavailable"]),
  goal: Schema.NullOr(ProviderGoal),
  error: Schema.optional(Schema.String),
});
export type ProviderGoalSnapshot = typeof ProviderGoalSnapshot.Type;

export const ProviderGoalAction = Schema.Struct({
  action: Schema.Literals(["refresh", "start", "edit", "resume", "pause", "clear", "stop"]),
  objective: Schema.optional(Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(4000))),
  tokenBudget: Schema.optional(
    Schema.NullOr(Schema.Number.check(Schema.isInt(), Schema.isGreaterThan(0))),
  ),
});
export type ProviderGoalAction = typeof ProviderGoalAction.Type;
